import { c as create_ssr_component, v as validate_component } from "../../../../chunks/ssr.js";
import { B as BookOpenPageVariant, S as ServicePageTemplate } from "../../../../chunks/ServicePageTemplate.js";
import { A as AccountCowboyHatOutline } from "../../../../chunks/AccountCowboyHatOutline.js";
import { A as AirplaneTakeoff } from "../../../../chunks/AirplaneTakeoff.js";
import { C as CheckDecagram } from "../../../../chunks/CheckDecagram.js";
import { C as CastEducation } from "../../../../chunks/CastEducation.js";
import { A as AirplaneClock } from "../../../../chunks/AirplaneClock.js";
import { C as ClipboardEdit } from "../../../../chunks/ClipboardEdit.js";
import { T as Turbine } from "../../../../chunks/Turbine.js";
import { H as HumanMaleBoard, N as NotebookCheckOutline, A as AccountSupervisor, B as BookEducation, S as School, a as AccountTieHat } from "../../../../chunks/School.js";
import { C as CopyCard } from "../../../../chunks/CopyCard.js";
const _page_svelte_svelte_type_style_lang = "";
const css = {
  code: ".desc.svelte-1ivvl6t{width:100%;padding:50px 50px;border-radius:40px;background-color:#fff;border:3px solid #f36d21;display:flex;flex-direction:column;gap:50px}@media(max-width: 800px){.desc.svelte-1ivvl6t{padding:0 5px;gap:20px}}.sections_wrapper.svelte-1ivvl6t{padding:50px 0;display:flex;flex-direction:column;align-items:center;gap:70px;overflow:hidden}@media(max-width: 800px){.sections_wrapper.svelte-1ivvl6t{padding:50px 5px}}.group.svelte-1ivvl6t{padding:0}@media(max-width: 800px){.group.svelte-1ivvl6t{padding:10px 5px}}@media(min-width: 1835px){.break.svelte-1ivvl6t{display:none}}",
  map: null
};
let pricingPackage = true;
let professionalProgram = true;
let rentalRates = false;
let programs = false;
let hero_image = "/flying_look_at_camera.webp";
let h1 = "Professional Pilot Program";
let background_center = false;
let hero_paragraph_content = "First Landings career pilot program prepares students for a variety of rewarding careers in aviation. Attending our structured, high quality airline pilot training ensures that you receive a solid foundation in all of the fundamentals that make up a well-rounded aviation education. With connections to the world’s best airlines and programs through our industry contacts, we produce top quality pilots and personnel that exceed commercial airline standards. Our students are sought after by flight departments and airlines around the world because they know that our students aren’t just great aviators, they have been trained to be professional pilots.";
let center_img_seperating_section = false;
let prerequisites = false;
const Page = create_ssr_component(($$result, $$props, $$bindings, slots) => {
  let roadmap_stages = [
    [
      {
        text: "Orientation / Discover flight",
        icon: AccountCowboyHatOutline
      },
      {
        text: "Private Pilot Training",
        icon: BookOpenPageVariant
      },
      {
        text: "Private Pilot Checkride",
        icon: AirplaneTakeoff
      },
      {
        text: "Private Pilot Acheived",
        icon: CheckDecagram
      }
    ],
    [
      {
        text: "Time Building",
        icon: AirplaneClock
      },
      {
        text: "Instrument Training",
        icon: CastEducation
      },
      {
        text: "Instrument Checkride",
        icon: ClipboardEdit
      },
      {
        text: "Instrument Add-on Acheived",
        icon: CheckDecagram
      }
    ],
    [
      {
        text: "Time building",
        icon: AirplaneClock
      },
      {
        text: "Commercial Pilot Training",
        icon: BookOpenPageVariant
      },
      {
        text: "Commercial Pilot Checkride",
        icon: AirplaneTakeoff
      },
      {
        text: "Commercial Pilot Achieved",
        icon: CheckDecagram
      }
    ],
    [
      {
        text: "Multi Engine Orientation",
        icon: AccountCowboyHatOutline
      },
      {
        text: "Multi Engine Training",
        icon: Turbine
      },
      {
        text: "Multi Engine Checkride",
        icon: ClipboardEdit
      },
      {
        text: "Multi Engine Add-on Achieved",
        icon: CheckDecagram
      }
    ],
    [
      {
        text: "CFI Training",
        icon: HumanMaleBoard
      },
      {
        text: "CFI Checkride",
        icon: NotebookCheckOutline
      },
      {
        text: "Start Instructing Students",
        icon: AccountSupervisor
      },
      { text: "CFII Course", icon: BookEducation }
    ],
    [
      {
        text: "CFII Checkride",
        icon: AirplaneTakeoff
      },
      { text: "MEI Course", icon: School },
      {
        text: "MEI Checkride",
        icon: AirplaneTakeoff
      },
      {
        text: "1500 Hours Achieved",
        icon: AccountTieHat
      }
    ]
  ];
  let second_center_img_seperating_section = {
    src: "/learning.webp",
    alt: "Instructor teaching student preflight"
  };
  $$result.css.add(css);
  return `${$$result.head += `<!-- HEAD_svelte-1nuieum_START -->${$$result.title = `<title>Career Pilot | First Landings Aviation</title>`, ""}<meta name="description" content="First Landings Aviation professional pilot training"><!-- HEAD_svelte-1nuieum_END -->`, ""}  ${validate_component(ServicePageTemplate, "ServicePageTemplate").$$render(
    $$result,
    {
      background_center,
      programs,
      pricingPackage,
      professionalProgram,
      rentalRates,
      hero_image,
      h1,
      hero_paragraph_content,
      roadmap_stages,
      center_img_seperating_section,
      second_center_img_seperating_section,
      prerequisites
    },
    {},
    {
      three: () => {
        return `<div slot="three">${validate_component(CopyCard, "CopyCard").$$render($$result, {}, {}, {
          text: () => {
            return `<div slot="text" data-svelte-h="svelte-1qsejc0">Receiving proper training is crucial to a pilot’s success, regardless of
        the career path they choose to pursue. Every job interview will test a
        pilot’s knowledge and flight skills because employers want to hire the
        most qualified pilot possible. Attending First Landings’ structured,
        high quality commercial airline pilot school training ensures that you
        receive a solid foundation in all of the fundamentals that make up a
        well-rounded aviation education. Our students are sought after by flight
        departments and airlines around the world because they know that our
        students aren’t just great aviators, they have been trained to be
        professional pilots.
        <br> <br>
        First Landings recognizes that one size does not fit all. We have programs
        designed for students that wish to attend the school full-time and complete
        their training in the shortest time possible. Our self-paced program is designed
        for students who wish to continue working while training, and features one-on-one
        ground school with the same great flight instruction. Both options will get
        you to your ultimate goal.</div>`;
          },
          heading: () => {
            return `<div slot="heading" data-svelte-h="svelte-zjnc4v">Start Your Career Today</div>`;
          }
        })}</div>`;
      },
      two: () => {
        return `<div slot="two" style="width: 100%;"><div class="sections_wrapper svelte-1ivvl6t" style="padding-top: 0; overflow: visible;">${validate_component(CopyCard, "CopyCard").$$render($$result, {}, {}, {
          text: () => {
            return `<div slot="text" data-svelte-h="svelte-1no0209">Do you enjoy exploring new destinations? Becoming a pilot is a
          fantastic way to see the world while getting paid for it. When you
          work for an airline, you can also take advantage of affordable travel
          during your leisure time, including free flights and discounts on
          hotels, rental cars, and tours.
          <br> <br>
          Being a pilot isn&#39;t a typical 9-to-5 job, and it may involve working nights
          or weekends occasionally. However, pilots often enjoy more time off compared
          to those in traditional jobs. Senior pilots at major airlines might have
          schedules with as few as seven workdays a month, while junior pilots at
          regional airlines frequently get blocks of three to five days off.
          <br> <br>
          Another exciting part of being a pilot is the challenge it brings. Flying
          a plane demands a mix of technical knowledge, decision-making abilities,
          and hand-eye coordination. Pilots find their job fulfilling because it
          combines mental and physical skills, making each workday different. Plus,
          they get to enjoy the best view from their &quot;office&quot; and they don&#39;t bring
          work home with them.
          <br> <br>
          Pay is a crucial part of any job. Senior captains flying large planes like
          the Boeing 747 or Airbus A380 can make up to $400,000 per year. While not
          all pilots earn this much, airline captains with a decade of experience
          usually make around $150,000 or more yearly at major airlines and about
          $80,000 per year at regional airlines. Additionally, pilots usually receive
          benefits like health insurance, life insurance, and 401K as part of their
          compensation.</div>`;
          },
          heading: () => {
            return `<div slot="heading" data-svelte-h="svelte-1bdkkjf">We are Experts in the Aviation Training Industry</div>`;
          }
        })}</div> <div class="desc svelte-1ivvl6t"><div class="sections_wrapper group svelte-1ivvl6t">${validate_component(CopyCard, "CopyCard").$$render($$result, {}, {}, {
          text: () => {
            return `<div slot="text" data-svelte-h="svelte-o2jbj6">Today the demand for pilots is outpacing the rate at which we can
            teach them. Current pilot job offers exceed $60k your first year
            with sign on bonuses.</div>`;
          },
          heading: () => {
            return `<div slot="heading" data-svelte-h="svelte-1cwjyvo">Immediate Job Openings</div>`;
          }
        })}</div> <div class="sections_wrapper group svelte-1ivvl6t">${validate_component(CopyCard, "CopyCard").$$render($$result, { blueBorder: true }, {}, {
          text: () => {
            return `<div slot="text" data-svelte-h="svelte-usy69b">With connections to the world’s best airlines and programs through
            our industry contacts, we produce top quality pilots and personnel
            that exceed commercial airline standards.</div>`;
          },
          heading: () => {
            return `<div slot="heading" data-svelte-h="svelte-1ybsaju">Connections</div>`;
          }
        })}</div> <div class="sections_wrapper group svelte-1ivvl6t">${validate_component(CopyCard, "CopyCard").$$render($$result, {}, {}, {
          text: () => {
            return `<div slot="text" data-svelte-h="svelte-1ne8ph4">Our program can take you from hour 0 to your multi engine commercial
            in as little as 6 months. After completing the course, you have the
            opportunity to be hired on as a CFI at First Landings Aviation.</div>`;
          },
          heading: () => {
            return `<div slot="heading" data-svelte-h="svelte-o6d2o9">0-Hour to Commercial Pilot</div>`;
          }
        })}</div></div></div>`;
      },
      one: () => {
        return `<div slot="one">${validate_component(CopyCard, "CopyCard").$$render($$result, { src: "/explaining.webp" }, {}, {
          text: () => {
            return `<div slot="text" data-svelte-h="svelte-1pvq28o">We&#39;re welcoming students to start an exciting journey toward becoming a
        Commercial Airline Pilot. New pilot certification rules have caused a
        shortage of qualified pilots in the aviation industry, affecting both
        commercial and airline pilots. Our First Landings career pilot program
        helps prepare students for fulfilling careers in aviation.</div>`;
          },
          heading: () => {
            return `<div slot="heading" data-svelte-h="svelte-euiubi">Begin Your Journey at <br class="break svelte-1ivvl6t"> First Landings Aviation</div>`;
          }
        })}</div>`;
      }
    }
  )}`;
});
export {
  Page as default
};
